/**
 * user接口统一管理
 */
import {del, get, post, put} from './http'

/**
 * 获取角色所在企业列表
 */
export const getRoleEntList = (params) => get('goodsmanual/app/active/user/list', params)

/**
 * 设置当前角色登录企业
 * @param params
 */
export const setDefaultLoginInfo = (params) => put('goodsmanual/role/ent/current', params)


/**
 * 根据code获取登录用户信息
 * @param params
 */
export const getPersonLoginInfoByCode = (params) => get('goodsmanual/tool/wechat/login/web', params)

/**
 * 获取绑定手机验证码
 * @param params
 */
export const getBindPhoneCode = (params) => post('goodsmanual/message/sms/bind', params)

/**
 * 微信登录绑定手机
 * @param params
 */
export const wxBindPhone = (params) => put('goodsmanual/user/bind/web/wechat', params)

/**
 * 获取登录二维码
 * @param params
 */
export const getLoginQrCode = (params) => get('goodsmanual/qrcode/login', params)

/**
 * 刷新登录二维码状态
 * @param session
 */
export const getLoginQrCodeStatus = (session) => get('goodsmanual/user/login/qrcode/session/' + session, {})

/**
 * 获取登录验证码短信
 * @param params
 */
export const getLoginSms = (params) => post('goodsmanual/message/sms/login', params)

/**
 * 短信登录
 * @param params
 */
export const smsLogin = (params) => post('goodsmanual/user/login/verify/ent', params)


export const login = (userName, passWd, entId) => post('goodsmanual/user/login/app', {
  phone: userName,
  pwd: passWd,
  isEnt: 1,
  entId: entId
})


export const registerPlatAdmin = (params) => post('goodsmanual/user/register/platadmin', params)

export const getUserInfo = () => get('goodsmanual/role', {})

export const editUserInfo = (params) => put('goodsmanual/user', params)

export const postSmsReg = (phone) => post('goodsmanual/message/sms/reg', {
  phone: phone
})

/**
 * 获取忘记密码短信
 * @param phone
 */
export const getForgetSmsReg = (phone) => post('goodsmanual/message/sms/forget', {
  phone: phone
})

/**
 * 修改忘记密码
 * @param params
 */
export const putUserPasswdForget = (params) => put('goodsmanual/user/pwd/forget', params)

/**
 * 注册+ 加入企业
 * @param params
 */
export const regEnt = (params) => post('goodsmanual/user/register/app/ent', params)

/**
 * 加入企业
 * @param params
 */
export const joinEnt = (params) => post('goodsmanual/user/ent/app/join', params)

/**
 * 切换企业
 * @param params
 */
export const setEntCheck = (params) => put('goodsmanual/user/ent/check', params)

/**
 * 获取员工
 * @param params
 */
export const getRoleList = (params) => get('goodsmanual/role/list', params)

/**
 * 获取审核+审核成功的成员列表
 * @param params
 */
export const getEmployees = (params) => get('goodsmanual/role/platform/list', params)
/**
 * 批量审核成员
 * @param params
 */
export const applyRole = (params) => put('goodsmanual/role/review', params)

/**
 * 设置角色
 * @param params
 */
export const setAdminRole = (params) => put('goodsmanual/role/set/type', params)

/**
 * 删除角色
 * @param roleId
 */
export const delRole = (roleId) => del('goodsmanual/role/' + roleId, {})

/**
 * 根据手机号获取登录信息
 * @param params
 */
export const getLoginInfobyPhone = (params) => get('goodsmanual/user/basic', params)

/**
 * 获取老刀号服务使用协议
 */
export const getProtocolUser = () => get('goodsmanual/protocol/user', {})

/**
 * 获取老刀号隐私协议
 */
export const getProtocolPrivacy = () => get('goodsmanual/protocol/privacy', {})
